<template>
  <section>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="137.229"
      height="90.887"
      viewBox="0 0 137.229 90.887"
    >
      <g
        id="Group_445"
        data-name="Group 445"
        transform="translate(-0.012 -51.548)"
      >
        <path
          id="Path_828"
          data-name="Path 828"
          d="M237.84,455.743c.051.024.1.048.158.069l-.142-.046q-1.019-.337-2.022-.715-1.613-.6-3.183-1.312-1.122-.5-2.222-1.058a55.957,55.957,0,0,1-16.946-13.115q-.648-.741-1.271-1.507-.53-.651-1.037-1.32a54.625,54.625,0,0,1-5.11-8.117,55.841,55.841,0,0,1-6.174-26.22,22.239,22.239,0,0,1,1.669-9.037,10.807,10.807,0,0,1,5.2-5.385c.192-.086.388-.165.586-.233a7.489,7.489,0,0,1,.935-.269c3.289-.724,6.762.756,9.212,3.066s4.059,5.357,5.539,8.384a212.571,212.571,0,0,1,12.021,29.907c.036.117.072.232.108.346a15.535,15.535,0,0,0-3.2,3.1L230.284,435a15.306,15.306,0,0,0-.86,2.191q-.147.473-.259.96A15.437,15.437,0,0,0,237.84,455.743Z"
          transform="translate(-199.874 -315.251)"
          fill="#f2f2f2"
        />
        <path
          id="Path_829"
          data-name="Path 829"
          d="M441.016,792.425l-.012.06,0,.014c0-.005,0-.009,0-.014,0-.022-.005-.045-.009-.067Z"
          transform="translate(-399.632 -650.905)"
          fill="#f2f2f2"
        />
        <path
          id="Path_830"
          data-name="Path 830"
          d="M262.408,438.161c.072.149.144.3.218.446q-.147.473-.259.96l-.233-.48q-1.883-3.861-3.663-7.768c-2.044-4.464-4.018-8.959-6-13.45l-6.244-14.185q-3.12-7.094-6.242-14.185a.4.4,0,0,1-.029-.106c-.036-.329.43-.568.586-.233l.005.009q.391.882.779,1.766l6.242,14.185,6.222,14.134c1.97,4.476,3.946,8.95,6,13.386Q261.078,435.412,262.408,438.161Z"
          transform="translate(-233.075 -316.665)"
          fill="#fff"
        />
        <path
          id="Path_831"
          data-name="Path 831"
          d="M429.112,789.956c-.115-.18-.23-.358-.343-.538-.1-.153-.194-.305-.29-.458-.024-.038-.048-.074-.069-.111q.473.147.95.281c.026.043.053.087.082.13.077.122.154.245.233.367.012.021.022.039.031.058C429.842,790.016,429.326,790.289,429.112,789.956Z"
          transform="translate(-389.209 -647.947)"
          fill="#fff"
        />
        <path
          id="Path_832"
          data-name="Path 832"
          d="M243.2,655.926c.141.2.28.394.417.593-.238.053-.475.1-.715.154-.19.038-.381.076-.571.11a32.361,32.361,0,0,1-34.857-17.329,13.014,13.014,0,0,1-1.573-5.143,6.331,6.331,0,0,1,1.247-4.2c.075-.1.156-.189.24-.28a4.693,4.693,0,0,1,.413-.391,5.39,5.39,0,0,1,3.239-1.175,7.473,7.473,0,0,1,2.372.28,16.475,16.475,0,0,1,5.139,2.859,123.3,123.3,0,0,1,15.178,13.16c.154.159.31.322.463.484a15.533,15.533,0,0,0,8.624,10.341.086.086,0,0,1,.015.022C242.96,655.581,243.082,655.753,243.2,655.926Z"
          transform="translate(-204.853 -514.896)"
          fill="#f2f2f2"
        />
        <path
          id="Path_833"
          data-name="Path 833"
          d="M425.9,793.08l-.026-.038.014,0Z"
          transform="translate(-387.105 -651.418)"
          fill="#f2f2f2"
        />
        <path
          id="Path_834"
          data-name="Path 834"
          d="M213.092,637.584l7.071,5.679,7.071,5.679c2.239,1.8,4.477,3.6,6.743,5.365,2.246,1.75,4.52,3.465,6.847,5.106s4.7,3.2,7.151,4.647q.458.27.918.534c.213.122.418-.2.2-.323-2.467-1.415-4.861-2.953-7.2-4.573s-4.624-3.322-6.877-5.062-4.5-3.539-6.729-5.331l-7.045-5.659-7.071-5.679-.88-.707C213.1,637.107,212.9,637.431,213.092,637.584Z"
          transform="translate(-210.752 -522.321)"
          fill="#fff"
        />
        <path
          id="Path_835"
          data-name="Path 835"
          d="M778.028,455.743c-.051.024-.1.048-.158.069l.142-.046q1.019-.337,2.022-.715,1.613-.6,3.183-1.312,1.122-.5,2.222-1.058a55.956,55.956,0,0,0,16.946-13.115q.648-.741,1.271-1.507.53-.651,1.038-1.32a54.63,54.63,0,0,0,5.11-8.117,55.841,55.841,0,0,0,6.174-26.22,22.239,22.239,0,0,0-1.669-9.037,10.807,10.807,0,0,0-5.2-5.385c-.192-.086-.388-.165-.586-.233a7.493,7.493,0,0,0-.935-.269c-3.289-.724-6.762.756-9.212,3.066s-4.059,5.357-5.539,8.384a212.582,212.582,0,0,0-12.021,29.907c-.036.117-.072.232-.108.346a15.534,15.534,0,0,1,3.2,3.1L785.583,435a15.309,15.309,0,0,1,.859,2.191q.147.473.259.96A15.438,15.438,0,0,1,778.028,455.743Z"
          transform="translate(-678.741 -315.251)"
          fill="#f2f2f2"
        />
        <path
          id="Path_836"
          data-name="Path 836"
          d="M758.86,792.425l.012.06,0,.014c0-.005,0-.009,0-.014,0-.022.005-.045.009-.067Z"
          transform="translate(-662.991 -650.905)"
          fill="#f2f2f2"
        />
        <path
          id="Path_837"
          data-name="Path 837"
          d="M828.078,438.161c-.072.149-.144.3-.218.446q.147.473.259.96l.233-.48q1.883-3.861,3.663-7.768c2.044-4.464,4.018-8.959,6-13.45l6.244-14.185q3.12-7.094,6.242-14.185a.407.407,0,0,0,.029-.106c.036-.329-.43-.568-.587-.233l-.005.009q-.391.882-.779,1.766l-6.242,14.185-6.222,14.134c-1.97,4.476-3.946,8.95-6,13.386Q829.408,435.412,828.078,438.161Z"
          transform="translate(-720.158 -316.665)"
          fill="#fff"
        />
        <path
          id="Path_838"
          data-name="Path 838"
          d="M764.517,789.956c.115-.18.23-.358.343-.538.1-.153.194-.305.29-.458.024-.038.048-.074.069-.111q-.473.147-.95.281c-.026.043-.053.087-.082.13-.077.122-.154.245-.233.367-.012.021-.022.039-.031.058C763.787,790.016,764.3,790.289,764.517,789.956Z"
          transform="translate(-667.167 -647.947)"
          fill="#fff"
        />
        <path
          id="Path_839"
          data-name="Path 839"
          d="M774.547,655.926c-.141.2-.279.394-.417.593.238.053.475.1.715.154.19.038.381.076.571.11a32.361,32.361,0,0,0,34.857-17.329,13.015,13.015,0,0,0,1.573-5.143,6.33,6.33,0,0,0-1.247-4.2c-.075-.1-.156-.189-.24-.28a4.7,4.7,0,0,0-.413-.391,5.39,5.39,0,0,0-3.239-1.175,7.473,7.473,0,0,0-2.372.28,16.475,16.475,0,0,0-5.139,2.859,123.283,123.283,0,0,0-15.178,13.16c-.154.159-.31.322-.463.484a15.534,15.534,0,0,1-8.624,10.341.088.088,0,0,0-.015.022C774.788,655.581,774.667,655.753,774.547,655.926Z"
          transform="translate(-675.642 -514.896)"
          fill="#f2f2f2"
        />
        <path
          id="Path_840"
          data-name="Path 840"
          d="M773.98,793.08l.026-.038-.014,0Z"
          transform="translate(-675.518 -651.418)"
          fill="#f2f2f2"
        />
        <path
          id="Path_841"
          data-name="Path 841"
          d="M812.146,637.584l-7.071,5.679L798,648.943c-2.239,1.8-4.477,3.6-6.743,5.365-2.246,1.75-4.52,3.465-6.847,5.106s-4.7,3.2-7.151,4.647q-.457.27-.918.534c-.213.122-.418-.2-.2-.323,2.467-1.416,4.862-2.953,7.2-4.573s4.624-3.322,6.877-5.062,4.5-3.539,6.729-5.331l7.045-5.659,7.071-5.679.88-.707C812.134,637.107,812.336,637.431,812.146,637.584Z"
          transform="translate(-677.233 -522.321)"
          fill="#fff"
        />
        <path
          id="Path_842"
          data-name="Path 842"
          d="M559.824,459.488a1.106,1.106,0,0,0-.641.564l-.881,1.791-.236.479a1.117,1.117,0,0,0,.507,1.493l6.826,3.358,12.1,5.953a1.117,1.117,0,0,0,1.454-.436c.014-.024.026-.047.039-.071l.674-1.371.443-.9a1.113,1.113,0,0,0-.509-1.492l-1.443-.71-10.675-5.25-6.811-3.352a1.114,1.114,0,0,0-.851-.055Z"
          transform="translate(-496.537 -375.018)"
          fill="#6c63ff"
        />
        <path
          id="Path_843"
          data-name="Path 843"
          d="M553.69,457.254a3.106,3.106,0,0,0-.323.566A3.176,3.176,0,0,0,554.989,462l5.334,2.355a1.119,1.119,0,0,0,1.055-.084,1.1,1.1,0,0,0,.318-.313,1.065,1.065,0,0,0,.1-.173l1.662-3.765a.163.163,0,0,0,.01-.027,1.114,1.114,0,0,0-.58-1.442l-5.334-2.355a3.177,3.177,0,0,0-3.86,1.055Z"
          transform="translate(-492.514 -372.119)"
          fill="#2f2e41"
        />
        <path
          id="Path_844"
          data-name="Path 844"
          d="M624.206,563.528h-2.531a1.116,1.116,0,0,0-1.115,1.115v15.779a1.116,1.116,0,0,0,1.115,1.115h2.531a1.115,1.115,0,0,0,1.115-1.115V564.643a1.115,1.115,0,0,0-1.115-1.115Z"
          transform="translate(-548.408 -461.266)"
          fill="#6c63ff"
        />
        <path
          id="Path_845"
          data-name="Path 845"
          d="M557.37,540.468a1.476,1.476,0,0,1-.539-.1l-14.1-5.516a1.53,1.53,0,0,1-.845-1.989l1.206-3.084a1.551,1.551,0,0,1,.809-.855,1.485,1.485,0,0,1,1.161-.032l14.1,5.516a1.486,1.486,0,0,1,.831.811,1.551,1.551,0,0,1,.014,1.177l-1.206,3.084A1.546,1.546,0,0,1,557.37,540.468Z"
          transform="translate(-483.133 -432.483)"
          fill="#ccc"
        />
        <path
          id="Path_846"
          data-name="Path 846"
          d="M624.439,665.175H621.7a.943.943,0,1,1,0-1.886h2.744a.943.943,0,1,1,0,1.886Z"
          transform="translate(-548.567 -543.919)"
          fill="#2f2e41"
        />
        <path
          id="Path_847"
          data-name="Path 847"
          d="M500.8,556.82a4.572,4.572,0,0,1-1.025-.108c-1.522-.351-2.084-1.02-2.177-1.359a.3.3,0,0,1,.056-.31.263.263,0,0,1,.281-.039c.473.158,7.176-1.168,9.557-1.717a2.535,2.535,0,0,1,2.065.112.666.666,0,0,1,.269.486v.06l-4.682,1.734A11.361,11.361,0,0,1,500.8,556.82Z"
          transform="translate(-446.513 -452.658)"
          fill="#2f2e41"
        />
        <path
          id="Path_848"
          data-name="Path 848"
          d="M508.012,594.395a.171.171,0,0,1-.157-.1L499.022,574.2a.512.512,0,0,0-.481-.307l-24.168.493a.512.512,0,0,0-.428.246l-11.6,18.967a.171.171,0,1,1-.293-.179l11.6-18.967a.854.854,0,0,1,.714-.41l24.168-.493a.858.858,0,0,1,.8.512l8.833,20.091a.172.172,0,0,1-.157.241Z"
          transform="translate(-417.062 -469.57)"
          fill="#2f2e41"
        />
        <path
          id="Path_849"
          data-name="Path 849"
          d="M539.162,603.66a.171.171,0,0,1-.165-.124l-5.59-19.45a.172.172,0,1,1,.33-.095l5.59,19.45a.172.172,0,0,1-.165.219Z"
          transform="translate(-476.195 -478.117)"
          fill="#2f2e41"
        />
        <path
          id="Path_850"
          data-name="Path 850"
          d="M528.846,526.363h-5.488A3.863,3.863,0,0,1,519.5,522.5v-.857a3.863,3.863,0,0,1,3.858-3.858h5.488a3.863,3.863,0,0,1,3.858,3.858v.857A3.863,3.863,0,0,1,528.846,526.363Z"
          transform="translate(-464.678 -423.37)"
          fill="#ccc"
        />
        <circle
          id="Ellipse_313"
          data-name="Ellipse 313"
          cx="1.029"
          cy="1.029"
          r="1.029"
          transform="translate(91.306 125.405)"
          fill="#2f2e41"
        />
        <circle
          id="Ellipse_314"
          data-name="Ellipse 314"
          cx="1.029"
          cy="1.029"
          r="1.029"
          transform="translate(42.946 125.405)"
          fill="#2f2e41"
        />
        <path
          id="Path_851"
          data-name="Path 851"
          d="M667.268,516.68a.6.6,0,0,1-.2-1.166l5.174-1.829a.6.6,0,1,1,.4,1.132l-5.174,1.829A.6.6,0,0,1,667.268,516.68Z"
          transform="translate(-586.608 -419.942)"
          fill="#2f2e41"
        />
        <path
          id="Path_852"
          data-name="Path 852"
          d="M590.325,619.195a.171.171,0,0,1-.123-.291l15.5-16.068a.171.171,0,0,1,.247.238l-15.5,16.068a.17.17,0,0,1-.123.052Z"
          transform="translate(-523.216 -493.79)"
          fill="#2f2e41"
        />
        <path
          id="Path_853"
          data-name="Path 853"
          d="M471.647,708.673a.172.172,0,0,1,0-.343l14.323-.042h0a.171.171,0,1,1,0,.343l-14.323.042Z"
          transform="translate(-424.889 -581.202)"
          fill="#2f2e41"
        />
        <path
          id="Path_854"
          data-name="Path 854"
          d="M671.489,537.584a.171.171,0,0,1-.167-.136l-.8-3.746a.171.171,0,0,1,.168-.207h2.721v-1.839a.172.172,0,0,1,.343,0v2.01a.171.171,0,0,1-.172.171H670.9l.758,3.539a.171.171,0,0,1-.168.207Z"
          transform="translate(-589.797 -434.717)"
          fill="#2f2e41"
        />
        <path
          id="Path_855"
          data-name="Path 855"
          d="M557.43,703.148a3.43,3.43,0,1,1,3.43-3.43A3.43,3.43,0,0,1,557.43,703.148Zm0-6.517a3.087,3.087,0,1,0,3.087,3.087A3.087,3.087,0,0,0,557.43,696.631Z"
          transform="translate(-493.262 -571.26)"
          fill="#2f2e41"
        />
        <path
          id="Path_856"
          data-name="Path 856"
          d="M575.439,712.175H572.7a.943.943,0,0,1,0-1.886h2.744a.943.943,0,0,1,0,1.886Z"
          transform="translate(-507.97 -582.859)"
          fill="#2f2e41"
        />
        <path
          id="Path_857"
          data-name="Path 857"
          d="M362.6,795.309H235.992a.2.2,0,0,1,0-.408H362.6a.2.2,0,1,1,0,.408Z"
          transform="translate(-229.62 -652.961)"
          fill="#3f3d56"
        />
        <path
          id="Path_858"
          data-name="Path 858"
          d="M570.343,432.595a1.106,1.106,0,0,0-.752.4l-1.265,1.544-.339.413a1.117,1.117,0,0,0,.154,1.569l5.883,4.823,10.432,8.551a1.117,1.117,0,0,0,1.515-.094c.019-.02.036-.039.054-.06l.969-1.181.636-.777a1.113,1.113,0,0,0-.156-1.569l-1.244-1.02-9.2-7.541-5.87-4.814A1.114,1.114,0,0,0,570.343,432.595Z"
          transform="translate(-504.641 -352.782)"
          fill="#6c63ff"
        />
        <circle
          id="Ellipse_315"
          data-name="Ellipse 315"
          cx="9.178"
          cy="9.178"
          r="9.178"
          transform="translate(52.771 55.128)"
          fill="#6c63ff"
        />
        <path
          id="Path_859"
          data-name="Path 859"
          d="M606.212,337.646l-.01-.343a2.837,2.837,0,0,0,1.623-.367,1.054,1.054,0,0,0,.408-.777.6.6,0,0,0-.2-.5,1.039,1.039,0,0,0-1.061-.009l-.284.13.544-3.977.34.047-.463,3.383a1.211,1.211,0,0,1,1.145.165.938.938,0,0,1,.319.77,1.394,1.394,0,0,1-.549,1.041A3.156,3.156,0,0,1,606.212,337.646Z"
          transform="translate(-536.513 -269.283)"
          fill="#2f2e41"
        />
        <rect
          id="Rectangle_959"
          data-name="Rectangle 959"
          width="1.847"
          height="0.343"
          transform="translate(66.913 62.863)"
          fill="#2f2e41"
        />
        <path
          id="Path_860"
          data-name="Path 860"
          d="M573.987,433.7l-4.092-4.153A3.173,3.173,0,0,0,565.374,434l4.092,4.153a1.114,1.114,0,0,0,1.4.152.922.922,0,0,0,.175-.14l2.932-2.888a1.1,1.1,0,0,0,.243-.355A1.121,1.121,0,0,0,573.987,433.7Z"
          transform="translate(-501.93 -349.474)"
          fill="#2f2e41"
        />
        <path
          id="Path_861"
          data-name="Path 861"
          d="M575.206,607.529h-2.531a1.116,1.116,0,0,0-1.115,1.115v15.779a1.116,1.116,0,0,0,1.115,1.115h2.531a1.115,1.115,0,0,0,1.115-1.115V608.643a1.115,1.115,0,0,0-1.115-1.115Z"
          transform="translate(-507.811 -497.721)"
          fill="#6c63ff"
        />
        <path
          id="Path_862"
          data-name="Path 862"
          d="M550.2,549.334a1.587,1.587,0,0,1-1.633-1.224L546,533.189a1.409,1.409,0,0,1,.326-1.145,1.874,1.874,0,0,1,1.134-.64l3.705-.637a1.641,1.641,0,0,1,1.972,1.195l2.566,14.921a1.41,1.41,0,0,1-.325,1.145,1.874,1.874,0,0,1-1.135.64l-3.705.637A1.991,1.991,0,0,1,550.2,549.334Z"
          transform="translate(-486.617 -434.099)"
          fill="#ccc"
        />
        <path
          id="Path_863"
          data-name="Path 863"
          d="M532.368,410.407a6.641,6.641,0,0,0-1.506-1.271,7.69,7.69,0,0,0-8.039.035,6.706,6.706,0,0,0-1.308,1.08,5.7,5.7,0,0,0-1.595,3.91v16.509a.724.724,0,0,0,.014.15,1.162,1.162,0,0,0,1.187.911h11.5a1.139,1.139,0,0,0,1.2-1.061V414.16A5.663,5.663,0,0,0,532.368,410.407Z"
          transform="translate(-465.026 -332.425)"
          fill="#2f2e41"
        />
        <path
          id="Path_864"
          data-name="Path 864"
          d="M518.14,281.29a2.02,2.02,0,0,1-2.66-1.735,2.052,2.052,0,0,1,.639-1.641,2.762,2.762,0,0,1,1.441-.638c1.155-.2,2.343-.038,3.5-.211a3.414,3.414,0,0,0,2.715-1.879,4.23,4.23,0,0,0,.03-3.442,6.037,6.037,0,0,0-2.728-2.769,10.68,10.68,0,0,0-7.314-.905,11.362,11.362,0,0,0-6.287,3.744q-.292.352-.553.727a.258.258,0,0,0,.222.387l1.5-.181-.222-.387L506.8,275.3c-.1.181.07.461.291.378l2.4-.9-.25-.43-2.38,2.9c-.208.254.153.62.364.364l2.38-2.9c.145-.176.016-.53-.25-.43l-2.4.9.29.378,1.635-2.94c.085-.154-.019-.412-.222-.387l-1.5.181.222.387a10.687,10.687,0,0,1,5.915-4.082,10.333,10.333,0,0,1,7.215.536,5.813,5.813,0,0,1,2.813,2.639,3.652,3.652,0,0,1-.121,3.3c-1.291,2.2-4.3,1.071-6.313,1.713a2.632,2.632,0,0,0-1.916,2.614,2.519,2.519,0,0,0,2.417,2.385,2.445,2.445,0,0,0,.9-.123c.313-.1.179-.6-.137-.5Z"
          transform="translate(-454.128 -216.252)"
          fill="#2f2e41"
        />
        <path
          id="Path_866"
          data-name="Path 866"
          d="M382.605,644.211a15.605,15.605,0,1,1,15.605-15.605A15.605,15.605,0,0,1,382.605,644.211Zm0-30.868a15.262,15.262,0,1,0,15.262,15.262,15.262,15.262,0,0,0-15.262-15.262Z"
          transform="translate(-338.33 -502.254)"
          fill="#2f2e41"
        />
        <path
          id="Path_867"
          data-name="Path 867"
          d="M664.605,644.211a15.605,15.605,0,1,1,15.605-15.605A15.605,15.605,0,0,1,664.605,644.211Zm0-30.868a15.262,15.262,0,1,0,15.262,15.262A15.262,15.262,0,0,0,664.605,613.343Z"
          transform="translate(-571.971 -502.254)"
          fill="#2f2e41"
        />
      </g>
    </svg>
  </section>
</template>

<script>
export default {
  props: {
    data: Array,
  },
  data() {
    return {};
  },
};
</script>